import { forwardRef } from 'react';
import type { PrescriptionCardPayload } from '@chewy/chat-library-common';
import { WidgetContainer, ActionButton, AdditionalInfo, OrderStatus, ProductImage } from '@chewy/chat-library-components';
import styles from './PrescriptionCardSelectorItem.module.scss';

interface PrescriptionCardSelectorItemProps {
  data?: PrescriptionCardPayload;
  isSelectable?: boolean;
  isSelected?: boolean;
  isUnselected?: boolean;
  onSelect?: () => void;
}

const PrescriptionCardSelectorItem = forwardRef<HTMLDivElement, PrescriptionCardSelectorItemProps>(
  ({ data, isSelectable = false, isSelected, isUnselected, onSelect }, ref) => {
  if (!data) {
    return null;
  }

  const {
    prescriptionId = '',
    items = [],
    actions = [],
    additionalMetaData = [],
    prescriptionState = '',
  } = data;
  // Assume there's only one prescription item in each order
  const hasActions = actions.length > 0;
  const hasAdditionalMetaData = additionalMetaData.length > 0;

  const prescriptionItem = items[0];
  const { name = '', imageUrl = '' } = prescriptionItem;
  const status = prescriptionState || '';

  return (
    <WidgetContainer
      data={data}
      onSelect={onSelect}
      isSelected={isSelected}
      isUnselected={isUnselected}
      isSelectable={isSelectable}
      hasActions={hasActions}
    >
      <div ref={ref} className={styles.container}>
        <div className={styles.imageContainer}>
          {imageUrl && <ProductImage imageUrl={imageUrl} name={prescriptionId} />}
        </div>
        <div className={styles.dataContainer}>
          {name && (
            <div className={styles.itemHeader}>
              {name && <span className={styles.itemName}>{name}</span>}
            </div>
          )}

          {hasAdditionalMetaData && (
            <AdditionalInfo additionalInfo={additionalMetaData} type="pharmacy" />
          )}
          {status && (
            <OrderStatus status={status} />
          )}
          {hasActions && (
            <div className={styles.actions}>
              {actions.map((action, index) => (
                <ActionButton
                  key={index}
                  widgetData={data}
                  action={action}
                />
              ))}
            </div>
          )}
        </div>

      </div>
    </WidgetContainer>
  );
});

export default PrescriptionCardSelectorItem;
